export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type ActiveSort = {
    sortKey: SortKey;
    direction: SortDirection;
};

export type LeaderboardActions = {
    type: 'SET_SORT';
    payload: SortKey;
};

export type LeaderboardDto = {
    userId: string;
    totalSize: string;
    totalVolume: string;
    totalMargin: string;
    realizedPnL: string;
    realizedPnLPercentage: string;
    losses: number;
    wins: number;
};

export type SortKey = keyof Omit<LeaderboardDto, 'userId'>;

export type LeaderboardTypes = {
    activeSort: ActiveSort;
    setSort: (key: SortKey) => void;
};
